/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'

import { ModalScreenWrapper } from 'shared/ModalScreenWrapper/ModalScreenWrapper'
import {
  MODAL_DETAILED_CLOSE_BUTTON_CONTAINER_ID,
  MODAL_DETAILED_DESKTOP_MAX_WIDTH,
} from 'ui/designSystem/ModalDetailed/constants'
import { ModalDetailedLayout } from 'ui/designSystem/ModalDetailed/ModalDetailedLayout'
import { ModalDetailedProps } from 'ui/designSystem/ModalDetailed/types'

const DESKTOP_MAX_HEIGHT = 'calc(100% - 64px)'

export const ModalDetailed: FunctionComponent<ModalDetailedProps> = (props) => (
  <ModalScreenWrapper
    title={props.title}
    onClose={props.onClose}
    fullScreen={!props.isLoading && !!props.hasFixedFooter}
    desktopMaxWidth={MODAL_DETAILED_DESKTOP_MAX_WIDTH}
    desktopMaxHeight={DESKTOP_MAX_HEIGHT}
    desktopVariant="bottomRight"
    initialFocusSelector={`#${MODAL_DETAILED_CLOSE_BUTTON_CONTAINER_ID} button`}>
    {(closeWithTransition, titleId) => (
      <ModalDetailedLayout {...props} onClose={closeWithTransition} titleId={titleId} />
    )}
  </ModalScreenWrapper>
)
